import { useCallback } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useAppSelector } from 'js/store/hooks';

export const useUpdateUserLocationChat = () => {
    const { enabled } = useAppSelector(prop('chatWidget'));

    return useCallback(() => {
        if (!enabled) {
            return;
        }

        window.Communication?.API?.chat?.updateUserLocation?.();
    }, [enabled]);
};
